/**
 * Enumeration of [ISO 4217 Currency Codes](https://en.wikipedia.org/wiki/ISO_4217) supported by Healthy Church Giving and financial functionality.
 */
enum Currency {
    /**
     * U.S. Dollar
     */
    USD = 'USD',
    /**
     * Canadian Dollar
     */
    CAD = 'CAD',
    /**
     * Euro
     */
    EUR = 'EUR',
    /**
     * Hong Kong Dollar
     */
    HKD = 'HKD',
    /**
     * Philippine peso
     */
    PHP = 'PHP',
}

export default Currency;
